import {Component, prop, watch} from 'vue-property-decorator';
import {Table} from "./table/table";
import {Selector} from "./selector/selector";
import {Diet} from "../models/diet";
import {Filters, filtersService} from "./filters/filters";
import {Save} from './save/save';
import {Print} from './print/print';
import Vue from 'vue';

@Component({
    template: require('./builder.html'),
    components: {
        "diet-table": Table,
        selector: Selector,
        filters: Filters,
        save: Save,
        print: Print,
    }
})
export class Builder {
    print_type  = 'hori';
    diet = null;
    subspecies = {diets: [], nutrients: [], adjustments: [], siblings: []};

    add = false;
    diets = [];

    filtered_nutrients = [];

    saving = false;
    printing = false;
    save_state = {
        id: window.save ? window.save.id : null,
        error: '',
        title: window.save ? window.save.title : ''
    };

    titles_height = 23;

    static inFilters(nut) {
        if(!filtersService.nutrient_type[nut.type]) {
            return false;
        }

        if((nut.unit_id == 2 || nut.unit_id == 13) && !filtersService.energy_unit[0]) {
            return false;
        }
        if((nut.unit_id == 3 || nut.unit_id == 15) && !filtersService.energy_unit[1]) {
            return false;
        }
        if((nut.unit_id == 4 || nut.unit_id == 14) && !filtersService.energy_unit[2]) {
            return false;
        }

        return (!nut.is_ratio || filtersService.ratio[nut.is_ratio - 1])
            && (!nut.fes_id || filtersService.fes == nut.fes_id - 1);
    }

    inDiets(nut) {
        return !!this.diets.find(d => {
            return !!d.enddata[nut.id];
        });
    }

    // This is triggered on filters change causing values to be recalculated as well.
    filterNutrients() {
        this.filtered_nutrients = this.subspecies.nutrients.filter(nut => {
            return Builder.inFilters(nut) && this.inDiets(nut);
        });
    }

    filters_changed() {
        this.filterNutrients();
    }

    created() {
        if(this.diet) {
            let diet = new Diet(this.diet.nutrients, this.reduceToGroups(this.diet.adjustments), this.diet.enddata, this.diet);
            this.diets.push(diet);
            this.filterNutrients();
        } else if(window.diets) {
            Promise.all(
                window.diets
                    .map(d => this.load_diet(d.id, d.values))
            ).then(this.insert_diets);
        }

        this.filters_changed();
    }

    add_diet(id, values) {
        return this.load_diet(id, values)
            .then(diet => this.insert_diets([diet]));
    }

    insert_diets(diets) {
        this.diets.push(...diets);
        this.filterNutrients();
    }

    @watch('diets')
    dc() {
        Vue.nextTick(() => {
            let max = 0;

            $('.diet-title').each(function () {
                max = Math.max($(this).height(), max);
            });

            this.titles_height = max;
        });
    }

    load_diet(id, values) {
        this.add = false;

        return $.get(window.lang + '/ajax/diet', {id})
            .then(r => {
                let diet = new Diet(r.nutrients, this.reduceToGroups(r.adjustments), r.enddata, r);

                function m(v) {
                    if(Array.isArray(v)) {
                        (v || []).forEach((value) => {
                            diet.adjustment_values[value[0]] = value[1];
                        });
                    } else {
                        Object.keys(v || {}).forEach(key => {
                            diet.adjustment_values[key] = v[key];
                        });
                    }
                }

                m(r.adjustment_defaults);
                m(values);

                return diet;
            });
    }

    close_selector() {
        this.add = false;
    }

    reduceToGroups(adjustments) {
        return adjustments.reduce((groups, adj) => {
            let group_i = groups.findIndex(group => group.title == adj.title);

            if(group_i < 0) {
                group_i = groups.push({
                        title: adj.title,
                        items: []
                    }) - 1;
            }

            groups[group_i].items.push(adj);

            return groups;
        }, []);
    }

    get grouped_adjustments() {
        return this.reduceToGroups(this.subspecies.adjustments);
    }

    change_species(id) {
        $.get(window.lang + '/ajax/subspecies', {id}, (r) => {
            this.subspecies = r;
            this.diets = [];
            this.filterNutrients();
        });
    }

    savenew(title) {
        this.save(title, true);
    }

    save(title, create_new) {
        console.log('tave?');
        if(!this.subspecies) {
            return;
        }

        let filter_values = this.diets.map(d => {
            let values = [];
            for(let i in d.adjustment_values) {
                if(d.adjustment_values[i] !== null) {
                    values.push([i, d.adjustment_values[i]]);
                }
            }

            return {
                id: parseInt(d.id),
                values: values,
            };
        });

        let data = {
            subspecies_id: this.subspecies.id,
            diets: filter_values,
            filters: filtersService,
            title: title,
        };

        this.save_state.error = '';

        let segments = [$('html').attr('lang'), 'save-diet'];

        if(this.save_state.id && !create_new) {
            segments.push(this.save_state.id);
        }

        $.post(segments.join('/'), {data: JSON.stringify(data)}, (r) => {
            history.replaceState({}, '', r.url);
            this.save_state.id = r.id;
            this.saving = false;
        }).fail(r => {
            if(!r.responseJSON.error) {
                return;
            }

            this.save_state.error = r.responseJSON.error;
        });
    }
    
    mounted(){

        $(window).bind('beforeunload', function(){
            return true;
        });
    }

    print(type){
        console.log(this.$refs.table.print(type));
    }
}
